
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class GSTR1Grid extends Serenity.EntityGrid<SalesTaxRow, any> {
        protected getColumnsKey() { return 'Sales.GSTR1'; }
        protected getIdProperty() { return SalesTaxRow.idProperty; }
        protected getInsertPermission() { return SalesTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesTaxRow.localTextPrefix; }
        protected getService() { return GSTR1Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }

        //protected getQuickFilters() {
        //    var filters = super.getQuickFilters();

        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: OMS.FinancialYearRow.lookupKey,
        //            multiple: true

        //        },
        //        field: 'FinancialYearId',
        //        title: 'Year',
        //        handler: w => {
        //            var temp= [];
        //            var values = w.value;
        //            for (var i = 0; i < values.length; i++) {
        //                temp.push(parseInt(values[i]));
        //            } if (temp.length != 0) {
        //                (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
        //                //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
        //                //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
        //            }
        //        },
                
        //        cssClass: 'hidden-xs'
        //    });
        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: OMS.CompanyRow.lookupKey,
        //            multiple: true

        //        },
        //        field: 'LedgerId',
        //        title: 'Company',
        //        handler: w => {
        //            var temp = [];
        //            var values = w.value;
        //            for (var i = 0; i < values.length; i++) {
        //                temp.push(parseInt(values[i]));
        //            } if (temp.length != 0) {
        //                (this.view.params as ReportFiltersRequest).CompanyIds = temp;
        //            }
        //        },

        //        cssClass: 'hidden-xs'
        //    });

        //    return filters;
        //}
        //protected createSlickGrid(): Slick.Grid {
        //    let grid = super.createSlickGrid();
        //    //grid.registerPlugin(this.autoSize);
        //    grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
        //    this.view.setGrouping([{

        //        getter: 'VoucherNo',
        //        displayTotalsRow: false,
        //    }])
        //    return grid;
        //}
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);


            //buttons.push(Common.PdfExportHelper.createToolButton({
            //    grid: this,
            //    onViewSubmit: () => this.onViewSubmit()
            //}));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print Register',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
            //        Common.ReportHelper.execute({
            //            reportKey: 'Finance.ContraRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}